/**
 * Export all publicly available constructs when the package is being published.
 */

export * from "@courses-models/institution/src/ts/models";
